export const isoToMmYyyy = (dirtyDate, replaceInvalidWith = '-') => {
  if (dirtyDate) {
    const date = new Date(dirtyDate)
    return `${String(date.getUTCMonth() + 1).padStart(2, 0)}/${String(date.getUTCFullYear())}`
  }

  return replaceInvalidWith
}

export const isoToFullYear = (dirtyDate, replaceInvalidWith = '-') => {
  if (dirtyDate) {
    return String(new Date(dirtyDate).getUTCFullYear())
  }

  return replaceInvalidWith
}



// WEBPACK FOOTER //
// ./src/utils/date.js